import React from "react";
import copy from "../lib/copy";

const pad = (n) => String(n).padStart(2, "0");

const Atlas = () => (
  <div className="atlas">
    {copy.markets.map((m, i) => (
      <div key={m.region} className="place">
        <span className="badge">SECTOR {pad(i + 1)}</span>
        <h4>{m.region}</h4>
        <p>{m.hubs}</p>
      </div>
    ))}
  </div>
);

export default Atlas;
